export const authToken = localStorage.getItem("accessToken");
export const isAuth = authToken ? true : false;
